import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FacebookIcon,
  FacebookShareButton,
  WhatsappShareButton,
  WhatsappIcon,
  LineShareButton,
  LineIcon,
  TwitterShareButton,
  TwitterIcon,
} from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import MetaTags from "react-meta-tags";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import ReactHtmlParser from "react-html-parser";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { getNewsBySlug } from "../../action/news";

var dayjs = require("dayjs");
var relativeTime = require("dayjs/plugin/relativeTime");
var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);

export default function NewsSlug() {
  const location = useLocation();
  const slug = location.pathname.slice(6);
  const [open, setOpen] = useState(false);
  const [news, setNews] = useState({});
  const [images, setImages] = useState({});

  const shareUrl = "https://ur-hub.com" + location.pathname;

  useEffect(() => {
    getNewsBySlug(slug).then((result) => {
      if (result && result.success === 1 && result.news && result.news.length > 0) {
        setNews(result.news[0]);
        try {
          const imagesJSON = JSON.parse(result.news[0].image);
          setImages(imagesJSON);
        } catch (e) {
          setImages({});
        }
      }
    });
  }, [slug]);

  const handleClose = () => {
    setOpen(false);
  };

  const firstImage =
    images.img1 ||
    (typeof news.image === "string" && news.image.startsWith("http")
      ? news.image
      : "https://res.cloudinary.com/urhub/image/upload/v1791947918/promo.webp");

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>{news.title ? `${news.title} | UR Blog` : "Blog | UR"}</title>
        <meta name="title" content={news.title || "UR Blog"} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={news.title || "UR Blog"} />
        <meta property="og:url" content={shareUrl} />
      </MetaTags>

      {/* Header Container */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "36px",
          backgroundColor: "#f8fafc",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <Container maxWidth="md">
          <Link
            to="/blog"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              color: "#DE148C",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "14px",
              marginBottom: "16px",
            }}
          >
            <ArrowBackIcon fontSize="small" /> Kembali ke Semua Artikel
          </Link>

          <Typography
            variant="h1"
            style={{
              fontWeight: 800,
              fontSize: "clamp(1.8rem, 3.5vw, 2.5rem)",
              lineHeight: 1.25,
              color: "#0f172a",
              letterSpacing: "-0.02em",
              marginBottom: "12px",
            }}
          >
            {news.title || "Loading..."}
          </Typography>

          {news.jam && (
            <div style={{ color: "#64748b", fontSize: "14px" }}>
              Dipublikasikan pada {dayjs(news.jam).format("LL")}
            </div>
          )}
        </Container>
      </section>

      {/* Article Body Section */}
      <section style={{ padding: "48px 0 80px 0" }}>
        <Container maxWidth="md">
          {/* Featured Image */}
          {firstImage && (
            <div
              style={{
                borderRadius: "14px",
                overflow: "hidden",
                border: "1px solid #e2e8f0",
                marginBottom: "36px",
                maxHeight: "420px",
                backgroundColor: "#0f172a",
              }}
            >
              <img
                src={firstImage}
                alt={news.title}
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight: "420px",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          )}

          {/* Article Text Content */}
          <div
            style={{
              color: "#334155",
              fontSize: "16px",
              lineHeight: 1.8,
              marginBottom: "40px",
            }}
          >
            {ReactHtmlParser(news.content || "")}
          </div>

          {/* Share Section Bar */}
          <div
            style={{
              padding: "20px 24px",
              borderRadius: "12px",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "12px",
            }}
          >
            <div>
              <div style={{ fontWeight: 600, fontSize: "14px", color: "#0f172a" }}>
                Bagikan Artikel Ini
              </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <FacebookShareButton url={shareUrl} quote={news.title}>
                <FacebookIcon size={34} round />
              </FacebookShareButton>

              <TwitterShareButton url={shareUrl} title={news.title}>
                <TwitterIcon size={34} round />
              </TwitterShareButton>

              <WhatsappShareButton url={shareUrl} title={news.title} separator=": ">
                <WhatsappIcon size={34} round />
              </WhatsappShareButton>

              <LineShareButton url={shareUrl} title={news.title}>
                <LineIcon size={34} round />
              </LineShareButton>

              <CopyToClipboard text={shareUrl}>
                <IconButton
                  onClick={() => setOpen(true)}
                  style={{
                    backgroundColor: "#0f172a",
                    color: "#ffffff",
                    width: "34px",
                    height: "34px",
                  }}
                  size="small"
                >
                  <FileCopyIcon style={{ fontSize: "16px" }} />
                </IconButton>
              </CopyToClipboard>
            </div>
          </div>
        </Container>
      </section>

      {/* Copy Alert Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Tautan Disalin</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Link artikel berhasil disalin ke clipboard Anda.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
